import { Image } from '@chakra-ui/react'
import React from 'react'
const quilmesImages = require.context('../assets/images', true)

const ProductImage = ({ item }) => {
  const { brand } = item

  return (
    <Image
      {...(
        brand !== null? (
        brand.description === 'Coca Cola'
        ? { src: quilmesImages('./coca.svg') }
        : brand.description === 'Pepsi'
          ? { src: quilmesImages('./pepsi.svg') }
          : brand.description === 'Fanta'
            ? { src: quilmesImages('./fanta.svg') }
            : brand.description === 'Sprite'
              ? { src: quilmesImages('./sprite.svg') }
              : brand.description === 'Speed'
                ? { src: quilmesImages('./speed.svg') }
                : brand.description === 'Awafrut'
                  ? { src: quilmesImages('./awafrut.svg') }
                  : brand.description === 'Mirinda'
                    ? { src: quilmesImages('./mirinda.svg') }
                    : brand.description === 'Levité'
                      ? { src: quilmesImages('./levite.svg') }
                      : brand.description === 'Rockstar'
                        ? { src: quilmesImages('./rockstar.svg') }
                        : brand.description === '7up'
                          ? { src: quilmesImages('./7up.svg') }
                          : brand.description === '7up Free'
                            ? { src: quilmesImages('./7upFree.svg') }
                            : brand.description === 'Pepsi Black'
                              ? { src: quilmesImages('./pepsiBlack.svg') }
                              : brand.description === 'Pepsi Light'
                                ? { src: quilmesImages('./pepsiLight.svg') }
                                : brand.description === 'Paso de los Toros'
                                  ? { src: quilmesImages('./pasoToros.svg') }
                                  : brand.description === 'Paso de los Toros Sin Azúcar'
                                    ? { src: quilmesImages('./pasoTorosGris.svg') }
                                    : brand.description === 'H2Oh!'
                                      ? { src: quilmesImages('./H2OH.svg') }
                                      : brand.description === 'Guaraná'
                                        ? { src: quilmesImages('./guarana.svg') }
                                        : brand.description === 'Gatorade'
                                          ? { src: quilmesImages('./gatorade.svg') }
                                          : brand.description === 'Gatorade NS'
                                            ? { src: quilmesImages('./gatoradeNS.svg') }
                                            : brand.description === 'Red Bull'
                                              ? { src: quilmesImages('./redBull.svg') }
                                              : brand.description === 'Crush'
                                                ? { src: quilmesImages('./crush.svg') }
                                                : brand.description === 'Manaos'
                                                  ? { src: quilmesImages('./manaos.svg') }
                                                  : brand.description === 'Powerade'
                                                    ? { src: quilmesImages('./Powerade.svg') }
                                                    : brand.description === 'Monster'
                                                      ? { src: quilmesImages('./monster.svg') }
                                                      : { src: quilmesImages('./empty.svg') }) : { src: quilmesImages('./empty.svg') }
      )}
      marginTop={'-1.1rem'}
      w='35px'
    />
  )
}

export default ProductImage
